<div class="font-upload-container" fxLayout="column">
  <div fxFlex="100%" fxFlexAlign="end">
    <button
      type="button"
      (click)="fileInput.click()"
      mat-button
      [ngClass]="uploadButtonClass"
      color="{{ uploadColor }}"
    >
      @if (iconDisplay) {
        <mat-icon>{{ iconDisplay }}</mat-icon>
      }
      {{ buttonLabel }}
    </button>
    <input
      type="file"
      #fileInput
      ng2FileSelect
      [uploader]="uploader"
      [accept]="acceptedFileTypes"
      id="fontUpload"
    />
    @if (displayDocumentScanningMessage) {
      <div
        class="scan-message"
        layout="row"
        layout-sm="column"
        layout-align="space-around"
      >
        Scan in progress.
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</div>
